










import { Component, Vue, Prop} from "vue-property-decorator";

@Component({
  name: 'IQuestion'
})

export default class IQuestion extends Vue {
  @Prop({ type: String, default: '#2D9CDB'}) protected color!: any
}
